import { useCallback } from 'react';
import { useAiSearchPartialToast } from '~/hooks/useAiSearchPartialToast';
import { useLocaleKeys } from '~/i18n';
import { useDraftsAiSearchStore } from './useDraftsAiSearchStore';
export const useDraftsAiSearchPartialToast = (toastTestId)=>{
    const { t: warningTexts } = useLocaleKeys('proposal.draftsDashboard.aiSearch.warnings');
    const searchPartial = useDraftsAiSearchStore((s)=>s.searchPartial);
    const setPartial = useDraftsAiSearchStore((s)=>s.setPartial);
    useAiSearchPartialToast({
        searchPartial,
        clearPartial: useCallback(()=>setPartial(false), [
            setPartial
        ]),
        message: warningTexts.partialCoverage(),
        toastTestId
    });
};
